import { useTranslations } from 'next-intl';
import { useMemo, useState } from 'react';

import ChevronIcon from '@/fo/icons/base/icons/chevron24.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';
import { UiKitSelectBase } from '@/fo/ui/kit/select/base';
import { useMediaQuery } from '@/fo/ui/mod/media/query';

import { FILTERS_SLUG, TYPES_FILTERS } from '../../constants';
import { FilterOption, SelectedFilters } from '../../types';

import { styles } from './TypeFilter.styles';

export interface TypeFilterProps {
  selectedFilters: SelectedFilters;
  handleTypeChange: (option: FilterOption | null) => void;
  groupPromotionsByType: (type: string) => number;
  className?: string;
}

export function TypeFilter({
  selectedFilters,
  handleTypeChange,
  groupPromotionsByType,
  className
}: TypeFilterProps) {
  const t = useTranslations();
  const slots = styles();
  const isDesktop = useMediaQuery('sm');
  const [open, setOpen] = useState(false);

  const typesFilters = useMemo(() => TYPES_FILTERS(t), [t]);
  const selectedFiltersBySlug = selectedFilters[FILTERS_SLUG.TYPE];
  const activeTypesFilters = typesFilters.filter(
    (item) => groupPromotionsByType(item.value) > 0
  );
  const selected =
    typesFilters.find((filter) =>
      selectedFiltersBySlug.includes(filter.value)
    ) || typesFilters[0];

  if (isDesktop) {
    return (
      <UiKitSelectBase
        className={slots.base({ className })}
        inputClassName={slots.input()}
        options={activeTypesFilters}
        selected={selected}
        onChange={handleTypeChange}
        withBorder={false}
        noInput
      />
    );
  }

  return (
    <UiKitDrawerBase
      title={selected.label}
      open={open}
      trigger={
        <UiKitButtonBase
          color={'ghost'}
          className={slots.base()}
          childrenClassName={slots.buttonChildren()}
        >
          <span className={slots.label()}>{selected.label}</span>
          <ChevronIcon className={slots.icon()} />
        </UiKitButtonBase>
      }
      onOpenChange={setOpen}
    >
      <ul>
        {typesFilters.map((option) => (
          <li key={option.value}>
            <UiKitButtonBase
              className={slots.button()}
              color={'ghost'}
              onClick={() => {
                handleTypeChange(option);
                setOpen(false);
              }}
            >
              {option.label}
            </UiKitButtonBase>
          </li>
        ))}
      </ul>
    </UiKitDrawerBase>
  );
}
